import styled, { css, createGlobalStyle } from "styled-components";
import FilteredPropsInputField from "./FilteredPropsInputField";
import { Form } from "formik";

export const GlobalStyle = createGlobalStyle`
/* Hide spinners and arrows in Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Hide spinners and arrows in Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

select {
    -webkit-appearance:none;
    -moz-appearance:none;
    appearance:none;
}

input[type=radio] {
    -ms-transform: scale(1.7); /* IE 9 */
    -webkit-transform: scale(1.7); /* Chrome, Safari, Opera */
    transform: scale(1.7);
    margin-left: 0.5rem;
}

option {
    padding: 0 1rem;
}

body {
    margin: 0;
}

h4 {
    font-size: 24px;
    font-weight: 300;
    font-family: "Roboto","Helvetica","Arial",sans-serif ;
    margin-bottom: 24px;
    margin-top: 0;
}

p {
    margin: 0;
}

@media screen and (max-width: 768px){
    #install-month, #install-year {
        width: 48%;
    }
}
`;

export const PageWrapper = styled.section`
    &,
    & * {
        box-sizing: border-box;
        display: block;
    }
    font-family: "Roboto", Helvetica, Arial, sans-serif;
    font-size: 1rem;
    line-height: 1.5rem;
    max-width: 50em;
    margin-left: auto;
    margin-right: auto;
    margin-top: 1.5rem;
    padding: 0;
    border: none;
    border-radius: 4px;
    letter-spacing: 0.25px;
    background: #fff;
    position: absolute;
    top: 0;
    @media screen and (min-width: 768px) {
        padding-right: 0;
    }
`;

export const CodeWrapper = styled.pre`
    font-family: monospace;
    font-size: 0.875rem;
    line-height: 1.25rem;
    background-color: hsl(210, 4%, 96%);
    overflow: auto;
    padding: 0.75rem;
    margin: 0;
    border-radius: 4px;
    @media screen and (min-width: 768px) {
        margin-top: 1rem;
        margin-right: 0.75rem;
    }
    & strong {
        margin-top: 1.5rem;

        &:first-child {
            margin-top: 0;
        }
    }
`;

export const ErrorWrapper = styled.section`
    visibility: ${({ showErrors }) => (showErrors ? "visible" : "hidden")};
    font-size: 0.875rem;
    line-height: 1.25rem;
    background-color: hsl(210, 4%, 96%);
    overflow: auto;
    padding: 0.75rem;
    margin: 0;
    border-radius: 4px;
    @media screen and (min-width: 768px) {
        margin-top: 1rem;
        margin-right: 0.75rem;
    }
    p {
        color: #981b1e;
    }
`;

export const ConfirmationWrapper = styled.div`
    padding: 20px;
`;

export const StyledForm = styled(Form)`
    padding: 0 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    border-color: ${({ submitted }) => submitted && "transparent"};
    @media screen and (min-width: 768px) {
        display: flex;
        flex-wrap: wrap;
    }
`;

export const Title = styled.h1`
    font-size: 1rem;
    line-height: 1.25rem;
    margin-top: 0;
`;

export const Label = styled.label`
    margin-top: 1rem;
    width: 100%;
    ${({ disabled }) =>
        disabled &&
        css`
            opacity: 0.5;
            pointer-events: none;
        `}
    ${({ column }) =>
        column &&
        css`
            label {
                margin-top: 0.25rem;
                width: auto !important;
                input {
                    margin-right: 1rem;
                }
            }
            textarea {
                margin: 0;
                margin-top: 0.5rem;
                resize: vertical;
                width: 100%;
                @media screen and (min-width: 768px) {
                    /* width: calc(100% - 0.75rem) !important; */
                }
            }
            margin-top: 1rem;
            display: flex;
            flex-direction: column;
            align-items: flex-start !important;
        `}
        @media screen and (min-width: 768px) {
        display: flex;
        justify-content: flex-start;
        flex-wrap: nowrap;
        align-items: center;
        width: 100%;
    }
`;

export const RadioGroup = styled.div`
    display: flex;
    flex-direction: column;
    label {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: 4rem;
        input {
            width: auto;
            flex-grow: 0;
            margin-top: 0;
        }
    }
    ${({ inline }) =>
        inline &&
        css`
            flex-direction: row;
            align-items: center;
            label {
                margin: 0;
            }
            @media screen and (min-width: 768px) {
                &:first-child {
                    margin-left: 0.5rem;
                }
            }
        `}
`;

export const Input = styled(FilteredPropsInputField)`
    &:not([type="radio"]):not([type="checkbox"]) {
        background-color: white;
        background: rgb(245, 245, 245);
        border: 1px solid rgba(0, 0, 0, 0.12);
        border-radius: 4px;
        font-size: 1rem;
        font-style: normal;
        font-weight: 400;
        width: ${(props) => (props.width ? props.width - 2 : "100")}%;
        padding: 10px;
        outline: none;
        &:focus,
        &:active {
            border: 1px solid rgb(241, 124, 132);
            outline: none;
        }

        /* Autocomplete styles in Chrome*/
        &:-webkit-autofill,
        &:-webkit-autofill:hover,
        &:-webkit-autofill:focus {
            background-color: white;
            border: 1px solid lightgrey;
            box-shadow: 0 0 0px 1000px #fff inset;
            -webkit-box-shadow: 0 0 0px 1000px #fff inset;
            transition: background-color 5000s ease-in-out 0s;
            -webkit-text-fill-color: black;
        }

        ${({ valid }) => valid && css``}
        outline: none;

        &:focus,
        &:active {
            border: 1px solid rgb(241, 124, 132);
            outline: none;
        }

        /* Autocomplete styles in Chrome*/
        /* &:-webkit-autofill,
        &:-webkit-autofill:hover,
        &:-webkit-autofill:focus {
            border: 2px solid #981b1e;
        } */

        ${({ error }) =>
            error &&
            css`
                box-shadow: rgb(152, 27, 30) 0px 0px 1px 0px,
                    rgb(248, 52, 78) 0px 0px 0px 1px;
            `}
    }
    @media screen and (min-width: 768px) {
        flex: 2;
        margin: 0 0.75rem 0 0.5rem;
        &:not([type="checkbox"]) {
            width: unset;
        }
    }
    width: ${(props) => props.isCheckbox && "unset"};
`;

export const StyledInlineErrorMessage = styled.div`
    background-color: rgb(255, 245, 245);
    color: rgb(120, 27, 0);
    display: block;
    padding: 0.5rem 0.75rem;
    margin-top: 0.5rem;
    white-space: pre-line;
    @media screen and (min-width: 768px) {
        margin-right: 1rem;
    }
`;

export const FlexWrapper = styled.div`
    display: flex;
    flex: 1;
    ${(props) =>
        props.spaceBetween &&
        css`
            justify-content: space-between;
        `}
`;

export const Submit = styled.button`
    width: 10rem;
    text-transform: uppercase;
    margin-top: 1.5rem;
    outline: none;
    border: none;
    border-radius: 4px;
    letter-spacing: 1px;
    background-color: #981b1e;
    display: block;
    text-align: center;
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    height: 2.5rem;
    white-space: nowrap;
    color: rgb(232, 243, 255) !important;
    padding: 0.5rem 1rem;

    &:active,
    &:focus,
    &:hover {
        cursor: pointer;
    }

    &:disabled {
        cursor: pointer;
        opacity: 0.5;
        box-shadow: none;
        color: rgb(255, 255, 255) !important;

        &:hover,
        &:focus {
            cursor: not-allowed;
        }
    }
`;

export const FieldWrapper = styled.div`
    width: ${(props) => (props.width !== 100 ? props.width - 2 : 100)}%;
    @media screen and (min-width: 768px) {
        display: flex;
        flex-direction: column;
        align-items: space-between;
        width: ${(props) => props.width - 2}%;
    }
`;

export const FileInput = styled.input`
    margin-top: 0.5rem;
`;
